module.exports = __webpack_public_path__ + "img/un_display_piece.121c4a96.png";